'use client'

import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js'
import { getStripe } from '@/lib/stripe-client'
import { ArrowLeft } from 'lucide-react'
import { useTranslations } from 'next-intl'
import '@/sass/EmbeddedCheckout.scss'
import SubscriptionCheckout from './SubscriptionCheckout'
import type { SubscriptionCheckoutUi } from '@/lib/stripeCheckoutUi'

interface Props {
  clientSecret: string
  uiMode?: SubscriptionCheckoutUi
  onClose: () => void
}

const stripePromise = typeof window !== 'undefined' ? getStripe() : null

const EmbeddedCheckoutForm = ({ clientSecret, uiMode = 'embedded', onClose }: Props) => {
  const t = useTranslations('PricingTable')

  return (
    <div className='embedded-checkout'>
      <button className='embedded-checkout__back' onClick={onClose} type='button'>
        <ArrowLeft size={16} />
        <span>{t('backToPlans')}</span>
      </button>

      <div className='embedded-checkout__frame'>
        {uiMode === 'custom'
          ? <SubscriptionCheckout clientSecret={clientSecret} />
          : (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
            )}
      </div>
    </div>
  )
}

export default EmbeddedCheckoutForm
